import { useState } from 'react'

import { EMPTY_LIST } from '../../../../../../constants/common'
import { useNotification, useTimeZone } from '../../../../../../hooks'
import {
  getIsViewingSlotBookable,
  performMockViewingApplicantsUpdate,
} from '../../../../../RentalPortalViewing'
import { useViewingProfileContext } from '../../../RentalPortalViewingProfile.hooks'
import { getViewingApplicantsRemovePayload } from '../../RentalPortalViewingProfileWidgetApplicants.utils'

export function useViewingApplicants() {
  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const timezone = useTimeZone()

  const { handleEntityReload, isInitiated, viewingData } =
    useViewingProfileContext()

  const [deletingApplicantId, setDeletingApplicantId] = useState(null)

  const applicants = viewingData?.applicants ?? EMPTY_LIST

  async function updateApplicants(payload) {
    return performMockViewingApplicantsUpdate({
      ...payload,
      viewing_id: viewingData?.id,
    })
  }

  async function handleSubmit(payload) {
    return updateApplicants(payload)
      .then(() => {
        handleAddSuccessNotification('Notification.CommonTitleSavedKey')

        return handleEntityReload()
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  async function handleDelete(applicantId) {
    setDeletingApplicantId(applicantId)

    return updateApplicants(
      getViewingApplicantsRemovePayload({ applicants, removedId: applicantId })
    )
      .then(() => {
        handleAddSuccessNotification('Notification.CommonTitleRemovedKey')

        return handleEntityReload()
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
      .finally(() => {
        setDeletingApplicantId(null)
      })
  }

  return {
    applicants,
    canBookSlot:
      viewingData &&
      getIsViewingSlotBookable({ timezone, viewing: viewingData }) &&
      viewingData.permissions?.can_manage,
    canManage: Boolean(viewingData?.permissions?.can_manage),
    deletingApplicantId,
    handleDelete,
    handleSubmit,
    isInitiated,
    listingId: viewingData?.listing_id,
  }
}
